import { NAMESPACE } from 'react/api/actions/base';

const actions = {
  updateUser: `${NAMESPACE}_UPDATE_USER`
}

const actionCreators = {
    updateUser: payload => ({ type: actions.updateUser, payload }),
}

export default {
  actions,
  actionCreators
};
